module.exports = __webpack_public_path__ + "img/no_goods.f6d19984.png";